
class QorpyApiInterface {
  constructor (isomorphicFetch, baseUrl, environment, businessKey, businessId) {
    this.fetch = isomorphicFetch
    this.baseUrl = baseUrl
    this.apiKey = businessKey
    this.businessId = businessId
    this.environment = environment
    this.BATCH_REQUEST_SIZE = 5
    this.PAGE_SIZE = 50
    this.INVOICE_TYPE_CODES = {
      CREDIT_NOTE: '380',
      COMMERCIAL_INVOICE: '381',
      DEBIT_NOTE: '384'
    }
    this.COUNTRY_CODES = {
      NG: 'NG'
    }
    this.CURRENCY_CODES = {
      NGN: 'NGN',
      USD: 'USD'
    }
    this.REQUEST_TYPES = {
      B2B: 'B2B',
      B2C: 'B2C'
    }
    this.PAYMENT_STATUS = {
      PAID: 'PAID',
      PENDING: 'PENDING',
      REJECTED: 'REJECTED'
    }
    this.TAX_CATEGORIES = {
      STANDARD_VAT: 'STANDARD_VAT',
      ZERO_VAT: 'ZERO_VAT'
    }
    // Medicaments; consisting of mixed or unmixed products n.e.c. in heading no. 3004, for therapeutic or prophylactic uses, packaged for retail sale
    this.DEFAULT_HS_CODE = '3004.90'
    this.DEFAULT_PRODUCT_CATEGORY = 'Medicaments'
    this.RESPONSE_CODES = {
      '02': 'invalid_tin',
      '00': 'success',
      '26': 'duplicate_invoice_number',
      '106': 'tax_total_cant_be_empty',
      '500': 'error_occured'
    }
  }

  /**
   * @param {string} path
   * @param {'POST'|'GET'} method
   * @param {Object} [body]
   */
  async request (path, method, body) {
    const endpoint = `${this.baseUrl}/${this.environment}/${path}`
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Business-Key': this.apiKey
      }
    }
    if (body) {
      Object.assign(options, {
        body: JSON.stringify(body)
      })
    }
    const response = await this.fetch(endpoint, options)
    return response.json()
  }

  createInvoice (data) {
    return this.request(`external/businesses/${this.businessId}/invoices`, 'POST', data)
  }

  /**
   * @param {string} invoiceIrn
   * @param {'PENDING'|'PAID'|'REJECTED'} status
  **/
  updateInvoicePaymentStatus (invoiceIrn, status = 'PENDING') {
    const query = new URLSearchParams({ invoiceStatus: status })
    return this.request(`external/businesses/${this.businessId}/invoices/update-payment/${invoiceIrn}?=${query.toString()}`, 'POST')
  }

  reverseInvoice (invoiceIrn) {
    return this.request(`external/businesses/${this.businessId}/invoices/reversal`, 'POST', { irn: invoiceIrn })
  }

  getInvoices (page = 1, count) {
    const query = new URLSearchParams({ size: count || this.PAGE_SIZE, page, invoiceType: 'INVOICES' })
    return this.request(`external/${this.businessId}/fetch-sent-invoices?${query.toString()}`, 'GET')
  }

  getCreditNotes (page = 1, count) {
    const query = new URLSearchParams({ size: count || this.PAGE_SIZE, page, invoiceType: 'CREDIT' })
    return this.request(`external/${this.businessId}/fetch-sent-invoices?${query.toString()}`, 'GET')
  }

  getDebitNotes (page = 1, count) {
    const query = new URLSearchParams({ size: count || this.PAGE_SIZE, page, invoiceType: 'DEBIT' })
    return this.request(`external/${this.businessId}/fetch-sent-invoices?${query.toString()}`, 'GET')
  }

  getCurrencies () {
    return this.request(`external/${this.businessId}/resources/currencies`, 'GET')
  }

  getStates () {
    return this.request(`external/${this.businessId}/resources/states`, 'GET')
  }

  getLgas () {
    return this.request(`external/${this.businessId}/resources/lgas`, 'GET')
  }

  getCountries () {
    return this.request(`external/${this.businessId}/resources/countries`, 'GET')
  }

  getInvoiceTypes () {
    return this.request(`external/${this.businessId}/resources/invoice-types`, 'GET')
  }

  getPaymentMeans () {
    return this.request(`external/${this.businessId}/resources/payment-means`, 'GET')
  }

  getProductCodes () {
    return this.request(`external/${this.businessId}/resources/product-codes`, 'GET')
  }

  getServiceCodes () {
    return this.request(`external/${this.businessId}/resources/service-codes`, 'GET')
  }

  getTaxCategories () {
    return this.request(`external/${this.businessId}/resources/tax-categories`, 'GET')
  }

  getFIRSTin (taxIdNumber) {
    return this.request(`external/${this.businessId}/resources/lookup-tin/${taxIdNumber}`, 'GET')
  }
}

module.exports = QorpyApiInterface
